import { Slide } from "react-reveal";
import FaqCard from "../reusables/FaqCard";
import OtherFAQs from "../reusables/OtherFAQs";

const WebsiteFaqsBody = () => {
  return (
    <section className="faqs section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center width-600 margin-auto section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">FAQS</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Frequently Asked Questions
                </h2>
              </Slide>
            </div>
            <div className="section-body">
              <ul className="faqs-container width-600 margin-auto">
                <FaqCard
                  faq="How long does it take to complete a website?"
                  answer="Because we have a wide and competent team, we usually deliver clients' websites starting from 3 days. The time of delivery is also dependent on how cooperative the client is in providing content and making on-time payments."
                />
                <FaqCard
                  faq="What do you need from me to get started?"
                  answer="We'll need an initial deposit, your business/company details or profile, content (text or images), branding materials and any specific content you want put on your website."
                />
                <FaqCard
                  faq="How much does a website cost?"
                  answer="Pricing depends on your project requirements. We provide a custom quotation based on your needs and budget."
                />
                <FaqCard
                  faq="Do you offer payment plans?"
                  answer="Yes. We offer flexible payment plans to make it easier for clients to invest in their website."
                />
                <FaqCard
                  faq="Will my website be secure?"
                  answer="Yes. We implement SSL, security best practices and protections to keep your website safe from hackers."
                />
                <FaqCard
                  faq="Do you use templates or pre-built themes?"
                  answer="No. We build every website from scratch ensuring maximum performance, security and full customization to your exact needs."
                />
                <FaqCard
                  faq="Will my website be mobile-friendly?"
                  answer="Yes. All our websites are fully responsive. Meaning, they open and work seamlesly across mobile, tablet and desktop devices."
                />
                <FaqCard
                  faq="Can you redesign my current website?"
                  answer="Yes. We can revamp your current website to improve its design, speed, functionality and overall performance."
                />
                <FaqCard
                  faq="Do you provide hosting and domain services?"
                  answer="Yes. We do domain name registration and website hosting on high-performance servers as part of our complete website development solution."
                />
                <FaqCard
                  faq="Will my website be optimized for search engines(SEO)?"
                  answer="Yes. We implement on-page SEO best practices to help your website rank better on search engines like Google."
                />
                <FaqCard
                  faq="Can I update the website myself after it's completed?"
                  answer="Yes. We give you access to your code and provide basic training to help you manage your website."
                />
                <FaqCard
                  faq="Do you offer website maintenance and support?"
                  answer="Yes. We offer ongoing support, updates and maintenance to ensure your website runs smoothly for your peace."
                />
              </ul>
            </div>
            <OtherFAQs />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WebsiteFaqsBody;

